<div class="unsubscribe-page" *ngIf="email">
  <div class="unsubscribe-page__wrapper section-wrapper">
    <div>
      <div class="a-section">
        <h1>{{ 'Unsubscribe.Title' | translate }}</h1>
        <div class="unsubscribe-page__message">
          <div><b>{{ email }}</b> {{ 'Unsubscribe.SuccessPrefix' | translate }}</div>
          <div>{{ 'Unsubscribe.Note' | translate }}</div>
          <div>{{ 'Unsubscribe.Thanks' | translate }}</div>
        </div>
      </div>
    </div>
    <div>
      <i class="app-ico app-ico__mail"></i>
    </div>
  </div>
</div>